<template>
    <!-- Modal -->
    <div class="modal fade" id="loginOrRegister" tabindex="-1" aria-labelledby="loginOrRegisterLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header d-flex justify-content-between border-0">
                    <button type="button" class="btn-close m-0" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body" >
                    <div class="d-flex justify-content-center mb-2">
                        <div class="py-3 px-4 border rounded rounded-circle pt-4">
                            <i class="fa-regular fa-user"></i>
                        </div>
                    </div>

                    <h5 class="modal-title text-center mb-3" id="loginOrRegisterLabel" >دخول  / تسجيل المستخدمين</h5>
                </div>

                <form @submit.prevent="sendCode()" v-if="codeSent == false">
                    <div class="modal-body" >
                        <div class="row g-4"  >
                            <span class="ec-login-wrap">
                                <label>{{ $t('Phone number') }}</label>
                                <input type="tel" class="form-control" id="login-mobile" placeholder="5×××××"
                                       aria-label="phone" aria-describedby="phone" v-model="item.mobile" dir="ltr" autofocus>
                            </span>
                        </div>
                    </div>
                    <div class="modal-footer px-3">
                        <button class="btn btn-primary px-5" type="submit">
                            {{ $t('Log In') }}
                        </button>
                    </div>
                </form>

                <form @submit.prevent="loginOrRegister()" v-if="codeSent == true">
                    <div class="modal-body" >
                        <div class="row g-4">
                            <span class="ec-login-wrap">
                                <label>كود الدخول</label>
                                <input type="text" class="form-control" id="login-code" placeholder="اكتب كود الدخول الذى وصلك هنا."
                                       aria-label="code" aria-describedby="code" v-model="item.code" dir="ltr"  autofocus>
                            </span>
                        </div>
                    </div>
                    <div class="modal-footer px-3 d-flex justify-content-between">
                        <button class="btn btn-secondary px-5" type="submit" @click="codeSent = false">
                            <i class="fa-solid fa-chevron-right"></i>
                        </button>
                        <button class="btn btn-primary px-5" type="submit">
                            {{ $t('Log In') }}
                        </button>
                    </div>
                </form>

            </div>
        </div>
    </div>
</template>

<script>
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
    inject: ['auth'],
    props:['type'],
    data() {
        return {
            item: {},
            codeSent: false,
            validationErrors: null,
        }
    },
    methods: {
        sendCode() {

            const id = toast.info(this.$t('Sending code...'),{ icon: 'fa-solid fa-cloud-arrow-up'  });

            const that = this;
            this.validationErrors = null;


            let formData = new FormData();
            Object.entries(this.item).forEach(([key, value]) => {
                formData.append(key, value);
            });

            axios.post('quick/send_login_code',
                formData
            ).then(response => {
                toast.dismiss(id);

                toast.success(response.data.message  ,{
                    timeout: 3000,
                },{ icon: 'fa-solid fa-circle-check'  });

                this.codeSent = true;
            }) .catch(function (error) {
                toast.dismiss(id);
                if (error.response) {
                    that.validationErrors = error.response.data.errors ;
                    toast.error(error.response.data.message  ,{
                        timeout: 3000,
                    },{ icon: 'fa-solid fa-circle-exclamation'  });
                }
            });

        },
        loginOrRegister() {

            const id = toast.info(this.$t('Adding content...'),{ icon: 'fa-solid fa-cloud-arrow-up'  });

            const that = this;
            this.validationErrors = null;


            let formData = new FormData();
            Object.entries(this.item).forEach(([key, value]) => {
                formData.append(key, value);
            });

            axios.post('quick/login-register',
                formData
            ).then(response => {
                toast.dismiss(id);

                toast.success(response.data.message  ,{
                    timeout: 3000,
                },{ icon: 'fa-solid fa-circle-check'  });

                this.item = {};

                localStorage.setItem('token', response.data.token);
                // reload page
                window.location.reload();


                $('#loginOrRegister').modal('hide');


            }) .catch(function (error) {
                toast.dismiss(id);
                if (error.response) {
                    that.validationErrors = error.response.data.errors ;
                    toast.error(error.response.data.message  ,{
                        timeout: 3000,
                    },{ icon: 'fa-solid fa-circle-exclamation'  });
                }
            });

        }
    },
};

</script>

<style scoped>
/* Add your component-specific styles here */
</style>
